import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";
import toast from "react-hot-toast";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../../../components/loader";
import { updateConfiguration, uploadCms } from "../../../api/endpoint";

const UpdateModal = ({
  isUpdateOpen,
  closeUpdateModal,
  fetchConfig,
}) => {
  const [pdfFile, setPdfFile] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { auth } = useSelector((state) => state.login);
  const { config } = useSelector((state) => state.config);

  const updateConfig = async (e) => {
    e.preventDefault();
    if (!pdfFile) {
      setError("No file uploaded");
      return;
    }
    const formData = new FormData();
    formData.append("file", pdfFile);
    try {
      setLoading(true);
      const uploadResponse = await axios.post(uploadCms, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadResponse.status === 200) {
        let fileName = uploadResponse.data.message;
        fileName = fileName?.split("/")?.pop();
        const newConfig = { ...config, privacyPolicyFile: fileName };
        try {
          setLoading(true);
          const response = await axios.post(updateConfiguration, newConfig, {
            headers: { Authorization: `Bearer ${auth}` },
          });
          toast.success("Privacy Policy Updated Successfully");
          closeUpdateModal();
          fetchConfig();
        } catch (error) {
          toast.error("Error Updating Privacy Policy");
          console.error("Error Updating Privacy Policy", error);
        } finally {
          setLoading(false);
        }
      }
    } catch (error) {
      toast.error("Error uploading file")
      console.error('Error uploading file', error)
    } finally {
      setLoading(false)
    }
  };
  
  return (
    <>
      {loading && <Loader />}
      <Modal show={isUpdateOpen} onHide={closeUpdateModal} centered>
        <Modal.Header>
          <h5 className="modal-title">Update Privacy Policy</h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeUpdateModal}
          ></button>
        </Modal.Header>
        <Modal.Body>
          <Input
            type="file"
            accept=".pdf"
            onChange={(e) => setPdfFile(e.target.files[0])}
          />
          {error && <div className="text-danger">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button text="Save" callBack={(e) => updateConfig(e)} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateModal;
